/**
 * @genesis_domain Configuration
 * @genesis_version V9.1
 * @genesis_intent Statically-declared environment variable mapping for Vite's compile-time substitution pass.
 * @genesis_boundaries FORBIDDEN from dynamic looping or object spreading on import.meta.env — Vite's static analyzer requires explicit per-key access.
 * @genesis_ai_trail Vite's define plugin replaces import.meta.env.VITE_* with string literals at build time. Whole-object access (spread, Object.keys, dynamic property access) is NOT statically analyzable and will produce undefined at runtime.
 */
import { z } from 'zod';

const EnvSchema = z.object({
  VITE_SUPABASE_URL: z.string().url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(1),
  VITE_API_URL: z.string().url().default('http://localhost:8788'),
});

// Explicit static property access — each key MUST be individually referenced
// so Vite's compiler can substitute the literal values at build time.
const configValues = {
  VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
  VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
  VITE_API_URL: import.meta.env.VITE_API_URL,
};

export const env = EnvSchema.parse(configValues);


